import React, { useEffect, useState } from "react";
import Loader from "../loader/loader";

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import barcodeIcon from '../../assets/img/icon1.svg';
import recordIcon from '../../assets/img/icon1.svg';
import myProfileIcon from '../../assets/img/icon3.svg';

import "./Dashboard.scss";

import { Grid, Button } from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";

import useOnlineStatus from "../../useOnlineStatus";

const InmateScanningPage = () => {
    let navigate = useNavigate();
    const isOnline = useOnlineStatus();
    const [activateLoader, setActivateLoader] = useState(false);

    const [show, setShow] = useState(false);
    const [isShow, setIsShow] = useState(true);

    const moduleAccessLocal = localStorage.getItem('module_access')
    const moduleAccess = moduleAccessLocal != 'undefined' ? JSON.parse(moduleAccessLocal) : {};
    const inmateModuleItems = moduleAccess?.INMATE_SCANNING?.items;

    const goToPage = (path) => {
        navigate(path)
    }

    return (
        <>
            <div className="container containerMainDiv">
                <div className="contentdivBg pt-0">
                    <div className="row dashboardDiv m-0">
                        <div className="divRound">
                            <Grid container className="MobileDiv text-center mt-5">
                                <Grid item xs={12} sm={1} className="ml-5"></Grid>
                            </Grid>
                            <Grid container>
                                {inmateModuleItems.map((item) => {
                                    return (<Grid item xs={12} sm={4}>
                                        <div className="cardBox inventoryBarcode" onClick={() => goToPage(item.path)}>
                                            <img src={barcodeIcon} />
                                            {item.displayName} <ArrowForwardIcon />
                                        </div>
                                    </Grid>)
                                })}
                            </Grid>


                        </div>
                    </div>
                </div>
            </div>
            <Loader active={activateLoader} />
        </>
    );
};
export default InmateScanningPage;
